/**
 * Default dialog close causes
 */
export enum DialogCloseCause {
    Succes,
    Cancel
}